import { Spinner } from "react-bootstrap";


export const LoadingButton = () => {
  return (
    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
  );
};